/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.printList = function( header, prtList) {
    var printWin = null;
    var stuff = document.createElement( "div");
    var html = "<!DOCTYPE html><html><head><title>Print List</title><style type='text/css'>";
    
    html += header.style + prtList.style + "}</style></head>";
    
//    html += header.style + prtList.style + "</style></head>";
    
    stuff.appendChild( header.content);
    stuff.appendChild( prtList.content);
    
    html += "<body>" + stuff.innerHTML + "</body></html>";
    
    printWin = window.open();
	printWin.document.write(html);
	printWin.document.close();
	printWin.focus();
	printWin.print();
	printWin.close();
    
    return;
};